import { LOCALES } from '../locales';
export default {
    [LOCALES.FRENCH]: {
        'hello': 'Bonjour',
        "Continue": "Continuer"

    }
}